// extracted by mini-css-extract-plugin
var _1 = "Cfzkp__chat";
export { _1 as "chat" }
